// Utility to track clicks on WhatsApp buttons
export const trackWhatsAppClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'whatsapp-click', {
        event_category: 'WhatsApp',
        event_label: 'WhatsApp Button Click',
      });
      console.log('tagged!')
    }
  };